import { PaymentMethodType } from "services/websocket/interfaces";
import { createAction } from "store/helper";

export interface IEntityBasePayload {
  additionalRequestId?: string;
  requestSource?: string;
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  requestData?: any;
}

export enum RequestAction {
  REQUEST = "REQUEST",
  SUCCESS = "SUCCESS",
  FAILURE = "FAILURE",
}

export enum CRUDAction {
  FETCH_SINGLE = "FETCH_SINGLE",
  FETCH_COLLECTION = "FETCH_COLLECTION",
  CREATE = "CREATE",
  UPDATE = "UPDATE",
  DELETE = "DELETE",
}

type IRequestNames = Record<RequestAction, string>;

type IActionNames = Record<CRUDAction, IRequestNames>;

type SelectorsNames = Record<CRUDAction, string>;

export interface IEntityFetch extends IEntityBasePayload {
  id: string;
}

export type IEnityCollectionFetch = IEntityBasePayload;

export interface IEntityRequestPromise {
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-empty-object-type
  resolve: (value?: {} | PromiseLike<{}>) => void;
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  reject: (reason?: any) => void;
}

export interface IEntityFetchSuccess<TEntity> extends IEntityFetch {
  value: TEntity;
}

export interface IEntityFetchCollectionSuccess<TEntity> extends IEntityBasePayload {
  values: TEntity[];
}

export interface IEntityCreate<TEntity> extends IEntityBasePayload {
  value: Partial<TEntity>;
  promise?: IEntityRequestPromise;
}

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/no-empty-object-type
export interface IEntityCreateSuccess<TEntity = {}> extends IEntityBasePayload {
  id: string;
  value?: TEntity;
}

export interface IEntityCreateFailure extends IRequestFailure {
  status?: string;
  id?: string;
  name?: string;
  flow?: string;
  errorObject?: {
    error?: {
      message: string;
      type: string;
      details?: {
        lackingSeats?: number;
        paymentMethod?: PaymentMethodType;
      };
    };
    details?: {
      errors?: {
        field: string;
        message: string;
      }[];
      target?: string;
      source?: "accounts";
      dcSyncURL?: string;
      lackingSeats?: number;
      paymentMethod?: PaymentMethodType;
    };
    message: string;
    type: string;
  };
}

export interface IEntityUpdate<TEntity> extends IEntityBasePayload {
  value: Partial<TEntity>;
  promise?: IEntityRequestPromise;
}

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/no-empty-object-type
export interface IEntityUpdateSuccess<TEntity = {}> extends IEntityBasePayload {
  id: string;
  value?: TEntity;
}

export interface IEntityUpdateFailure extends IRequestFailure {
  id: string;
  errorObject?: {
    details?: {
      errors?: {
        field: string;
        message: string;
      }[];
      target?: string;
      source?: "accounts";
    };
    message: string;
    type: string;
  };
}

export interface IEntityDelete extends IEntityBasePayload {
  id?: string;
}

export interface IEntityDeleteSuccess extends IEntityBasePayload {
  id?: string;
}

export interface IEntityDeleteFailure {
  id?: string;
}

export interface IRequestFailure extends IEntityBasePayload {
  error?: string | null;
}

export interface IRequestErrorWithDetails {
  type: string;
  error: string;
  details: { errors: { field: string; error: string }[] };
}

export interface IEntityFetchFailure extends IRequestFailure {
  id: string;
}

export interface IRequestError {
  type: string;
  message: string;
}

export type IEntityFetchCollectionFailure = IRequestFailure;

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const createRequestTypes = (base: string) =>
  [RequestAction.REQUEST, RequestAction.SUCCESS, RequestAction.FAILURE].reduce(
    (acc, type) => ({
      ...acc,
      [type]: `${base}_${type}`,
    }),
    {} as IRequestNames
  );

const CRUDActions = [
  CRUDAction.FETCH_SINGLE,
  CRUDAction.FETCH_COLLECTION,
  CRUDAction.CREATE,
  CRUDAction.UPDATE,
  CRUDAction.DELETE,
];

export const createEntityActionNames: (base: string) => IActionNames = base =>
  CRUDActions.reduce(
    (acc, type) => ({
      ...acc,
      [type]: createRequestTypes(`${type}_${base}`),
    }),
    {} as IActionNames
  );

export const createEntitySelectorsNames: (base: string) => SelectorsNames = base =>
  CRUDActions.reduce(
    (acc, type) => ({
      ...acc,
      [type]: `${type}_${base}`,
    }),
    {}
  ) as SelectorsNames;

export const createEntityActions = <
  TEntity,
  TEntityFetch = IEntityFetch,
  TEntityFetchCollection = IEnityCollectionFetch,
>(
  actionNames: IActionNames
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
) => ({
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  fetch: (payload: TEntityFetch) => createAction(actionNames[CRUDAction.FETCH_SINGLE][RequestAction.REQUEST], payload),

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  fetchSuccess: (payload: IEntityFetchSuccess<TEntity>) =>
    createAction(actionNames[CRUDAction.FETCH_SINGLE][RequestAction.SUCCESS], payload),

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  fetchFailure: (payload: IEntityFetchFailure) =>
    createAction(actionNames[CRUDAction.FETCH_SINGLE][RequestAction.FAILURE], payload),

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  fetchCollection: (payload: TEntityFetchCollection) =>
    createAction(actionNames[CRUDAction.FETCH_COLLECTION][RequestAction.REQUEST], payload),

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  fetchCollectionSuccess: (payload: IEntityFetchCollectionSuccess<TEntity>) =>
    createAction(actionNames[CRUDAction.FETCH_COLLECTION][RequestAction.SUCCESS], payload),

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  fetchCollectionFailure: (payload: IEntityFetchCollectionFailure) =>
    createAction(actionNames[CRUDAction.FETCH_COLLECTION][RequestAction.FAILURE], payload),

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  create: (payload: IEntityCreate<TEntity> & { skipRetry?: boolean }) =>
    createAction(actionNames[CRUDAction.CREATE][RequestAction.REQUEST], payload),

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  createSuccess: (payload: IEntityCreateSuccess) =>
    createAction(actionNames[CRUDAction.CREATE][RequestAction.SUCCESS], payload),

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  createFailure: (payload: IEntityCreateFailure) =>
    createAction(actionNames[CRUDAction.CREATE][RequestAction.FAILURE], payload),

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  update: (payload: IEntityUpdate<TEntity>) =>
    createAction(actionNames[CRUDAction.UPDATE][RequestAction.REQUEST], payload),

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  updateSuccess: (payload: IEntityUpdateSuccess) =>
    createAction(actionNames[CRUDAction.UPDATE][RequestAction.SUCCESS], payload),

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  updateFailure: (payload: IEntityUpdateFailure) =>
    createAction(actionNames[CRUDAction.UPDATE][RequestAction.FAILURE], payload),

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  delete: (payload: IEntityDelete) => createAction(actionNames[CRUDAction.DELETE][RequestAction.REQUEST], payload),

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  deleteSuccess: (payload: IEntityDeleteSuccess) =>
    createAction(actionNames[CRUDAction.DELETE][RequestAction.SUCCESS], payload),

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  deleteFailure: (payload: IEntityDeleteFailure & { isOwnerDeletion?: boolean }) =>
    createAction(actionNames[CRUDAction.DELETE][RequestAction.FAILURE], payload),
});
